export enum SavedFilterSetupMode {
    create,
    edit,
}
